import type { PageNumber } from "@pdfking/renderer-api"
import { NullQ } from "@pdfking/structs"

/** The signature of a book that `page` is in, the signatures holding
 * `sides_tuple` pages each, one after the other in the reading order: its
 * index from 0 and how many pages it has; none for a page with no place. */
export const GrowSignature = (
  sides_tuple: number[],
  page: PageNumber | undefined
): { index: number; pages: number } | undefined => {
  if (NullQ(page)) return undefined
  let last = 0
  for (const [index, pages] of sides_tuple.entries()) {
    last += pages
    if (page <= last) return { index, pages }
  }
  return undefined
}
